import {VmView} from 'components'

export default function DefaultChildren() {
  return (
    <VmView className="w-full h-full flex justify-center items-center text-center rounded-lg bg-red1-stripes">
      Children
    </VmView>
  )
}
